module.exports = __webpack_public_path__ + "static/media/GolosText-SemiBold.93514da9.ttf";